import { formatPrice } from './formatPrice';

export const centsToEuros = (cents: number): number => cents / 100;

export const eurosToCents = (euros: number): number => euros * 100;

export const formatPriceFromCents = (
	cents: number,
	showCurrency = true,
	rounded = false
): string => formatPrice(centsToEuros(cents), showCurrency, rounded);
